import React from "react";
import { Box, Chip } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  resetClubNameFilter,
  resetLeagueFilter,
  resetStarRatingFilter,
  resetTargetStarRatingFilter,
  setClubNameFilter,
  setLeagueFilter,
  setStarRatingFilter,
  setTargetStarRatingFilter,
} from "../../redux/reducers/common";
import { colors } from "../../common/pallette/colors";

const starLabel = (count: number) => "★".repeat(count);

const ActiveFilterChips = () => {
  const dispatch = useDispatch();
  const selectedClubs = useSelector((state: any) => state.common.clubNameFilter);
  const selectedLeagues = useSelector((state: any) => state.common.leagueFilter);
  const selectedStars = useSelector((state: any) => state.common.starRatingFilter);
  const selectedTargetStars = useSelector(
    (state: any) => state.common.targetStarRatingFilter
  );

  const hasAny =
    selectedClubs.length > 0 ||
    selectedLeagues.length > 0 ||
    selectedStars.length > 0 ||
    selectedTargetStars.length > 0;

  if (!hasAny) return null;

  const clearAll = () => {
    dispatch(resetClubNameFilter());
    dispatch(resetLeagueFilter());
    dispatch(resetStarRatingFilter());
    dispatch(resetTargetStarRatingFilter());
  };

  const chipSx = {
    fontSize: "11px",
    height: "22px",
    backgroundColor: `${colors.blue.navy}12`,
    color: colors.blue.navy,
    border: `1px solid ${colors.blue.navy}30`,
    "& .MuiChip-deleteIcon": {
      fontSize: "13px",
      color: `${colors.blue.navy}80`,
      "&:hover": { color: colors.blue.navy },
    },
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: "6px",
        mt: "6px",
        alignItems: "center",
      }}
    >
      {selectedClubs.map((c: any) => (
        <Chip
          key={`club-${c.id}`}
          label={c.name}
          size="small"
          onDelete={() =>
            dispatch(setClubNameFilter(selectedClubs.filter((x: any) => x.id !== c.id)))
          }
          sx={chipSx}
        />
      ))}
      {selectedLeagues.map((l: any) => (
        <Chip
          key={`league-${l.id}`}
          label={l.name}
          size="small"
          onDelete={() =>
            dispatch(
              setLeagueFilter(selectedLeagues.filter((x: any) => x.id !== l.id))
            )
          }
          sx={chipSx}
        />
      ))}
      {selectedStars.map((s: any) => (
        <Chip
          key={`star-${s.id}`}
          label={`${starLabel(s.id)} Rating`}
          size="small"
          onDelete={() =>
            dispatch(
              setStarRatingFilter(selectedStars.filter((x: any) => x.id !== s.id))
            )
          }
          sx={chipSx}
        />
      ))}
      {selectedTargetStars.map((s: any) => (
        <Chip
          key={`target-${s.id}`}
          label={`${starLabel(s.id)} Target`}
          size="small"
          onDelete={() =>
            dispatch(
              setTargetStarRatingFilter(
                selectedTargetStars.filter((x: any) => x.id !== s.id)
              )
            )
          }
          sx={chipSx}
        />
      ))}
      <Chip
        label="Clear all"
        size="small"
        onClick={clearAll}
        sx={{
          fontSize: "11px",
          height: "22px",
          backgroundColor: "transparent",
          color: colors.grey.dark,
          border: `1px solid ${colors.grey.light}`,
          cursor: "pointer",
          "&:hover": { backgroundColor: colors.grey.light },
        }}
      />
    </Box>
  );
};

export default ActiveFilterChips;
